<template>
    <div class="container">
        <div class="head_card">
            <van-row>
                <van-col span="6" class="avatar">
                    <img src="@/assets/themetwo/head_37.png" alt="">
                </van-col>
                <van-col span="14" style="display: flex; flex-direction: column; justify-content: center;padding-left: 5px;">
                    <div class="id"> {{ name }} </div>
                    <div class="contact">{{ $t('profile.id') }} : {{ id }}
                        <img src="@/assets/themetwo/icon-copy.png" alt="" @click="onCopyID(id)">
                    </div>

                    <div class="value">
                        <span style="color: #88f2fa;">{{ $t('common.balance') }} </span>
                        <span style="color: gold;"> R$ {{ formatCurrency(balance) }}</span>
                    </div>
                </van-col>
                <van-col span="4" class="mail">
                </van-col>
                <van-col span="12" class="withdraw_btn">
                    <PrimaryButton :text="$t('common.sake')" textColor="#FFFFFF" bgColor="#fd66b1"
                        @onClick="onButtonClick('withdraw')" />
                </van-col>
                <van-col span="12" class="deposit_btn">
                    <PrimaryButton :text="$t('common.deposite')" textColor="#752700" bgColor="#ffc809"
                        @onClick="onButtonClick('topup')" />
                </van-col>
            </van-row>
        </div>

        <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
        <CarteiraView ref="walletPopupRef"/>
    </div>
</template>

<script setup lang="ts">
import PrimaryButton from '../../components/common/primaryButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)
const walletPopupRef = ref()

const onClickCard = () => clickOnCard(router, isPopping, '/sd-message')
const onCopyID = (id: any) => copyID(statusRef, id)
const onButtonClick = (type: string) => {
    if (type === 'withdraw') {
        // router.push({ path: '/sd-carteira', query: { tab: 1 } });
        walletPopupRef?.value?.openPopup(1)
    } else if (type === 'topup') {
        walletPopupRef?.value?.openPopup(0)
        // router.push({ path: '/sd-carteira', query: { tab: 0 } });
    }
}

</script>
<style scoped>
.container {
    padding: 20px 10px;
}

.head_card img {
    width: 100%;
}

.avatar img {
    width: 80px;
    border-radius: 20px;
    border: .02667rem solid hsla(0, 0%, 100%, .25);
}

@media (max-width:450px) {
    .content {
        margin: -39vw 0 1vh 0;
        padding: 0 15px;
    }
}

@media (min-width: 500px) {
    .content {
        margin: -22vh 0 6vh 0;
        padding: 0 15px;
        font-size: 2.1vh;
    }

    .head_card {
        /* padding: 1vw; */
        padding-bottom: 0;
    }

    .button_container {
        font-size: 2.1vh;
    }
}

@media (min-width: 1440px) {
    .content {
        margin: -11vw 0 3vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }

    .button_container {
        font-size: 1vw;
    }
}

@media (min-width: 1920px) {
    .content {
        margin: -9vw 0 6vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }

    .head_card {
        /* padding: 1vw; */
        padding-bottom: 0;
    }

    .button_container {
        font-size: 1vw;
    }
}

.mail {
    display: flex;
    justify-content: right;
}

.mail img {
    width: 30px;
    height: 32px;
}

.id {
    color: #fff;
    display: flex;
    font-size: 15px;
    align-items: center;
    flex-direction: row;
}



.contact {
    color: #fff;
    font-size: 15px;
    align-items: center;
    display: flex;
}

.contact img {
    width: 25px;
    padding: 0 5px;
}

.value {
    color: rgba(255, 255, 255, 0.65);
    font-size: 18px;

}

.value span {
    color: #fff;
    font-size: 14.25px;
    /* font-weight: bold; */
}

.withdraw_btn {
    padding: 5px;
}

.deposit_btn {
    padding: 5px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.75);
    }

    100% {
        transform: scale(1);
    }
}
</style>